// PopupComponent.jsx
import React from "react";
import "./tableComponent.scss";

const Table = ({
    pagination = false,
    columns = null,
    data = null,
    rowKey = null,
    sortField = null,
    sortOrder = null,
    onSort = null
}) => {

  const resolvedColumns = Array.isArray(columns) && columns.length > 0 ? columns : null;
  const resolvedData = Array.isArray(data) ? data : null;

  const getRowKey = (row, index) => {
    if (typeof rowKey === "function") return rowKey(row, index);
    if (typeof rowKey === "string" && row && typeof row === "object" && rowKey in row) return row[rowKey];
    return index;
  };

  const handleSort = (columnKey) => {
    if (onSort && typeof onSort === "function") {
      onSort(columnKey);
    }
  };

  const getSortIcon = (columnKey) => {
    if (sortField === columnKey) {
      return sortOrder === "asc" ? " ↑" : " ↓";
    }
    return "";
  };

  return (
    <div className="customTableWrapper">
        <div className="tableInner table-responsive">
            <table className="table">
                <thead>
                    <tr>
                      {resolvedColumns ? (
                        resolvedColumns.map((col, idx) => (
                          <th 
                            key={col?.key || idx} 
                            scope="col"
                            onClick={() => col?.sortable && handleSort(col?.key)}
                            style={{
                              cursor: col?.sortable ? "pointer" : "default",
                              userSelect: "none"
                            }}
                          >
                            {col?.header}{col?.sortable && getSortIcon(col?.key)}
                          </th>
                        ))
                      ) : (
                        <>
                          <th scope="col">#</th>
                          <th scope="col">First</th>
                          <th scope="col">Last</th>
                          <th scope="col">Handle</th>
                        </>
                      )}
                    </tr>
                </thead>
                <tbody>
                  {resolvedColumns && resolvedData ? (
                    resolvedData.length > 0 ? (
                      resolvedData.map((row, rowIndex) => (
                        <tr key={getRowKey(row, rowIndex)}>
                          {resolvedColumns.map((col, colIndex) => (
                            <td key={col?.key || colIndex}>
                              {typeof col?.cell === "function" ? col.cell(row, rowIndex) : row?.[col?.accessor]}
                            </td>
                          ))}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={resolvedColumns.length}>
                          <div className="text-muted">No records found.</div>
                        </td>
                      </tr>
                    )
                  ) : (
                    <>
                      <tr>
                          <th scope="row">1</th>
                          <td>Mark</td>
                          <td>Otto</td>
                          <td>@mdo</td>
                      </tr>
                      <tr>
                          <th scope="row">2</th>
                          <td>Jacob</td>
                          <td>Thornton</td>
                          <td>@fat</td>
                      </tr>
                      <tr>
                          <th scope="row">3</th>
                          <td>John</td>
                          <td>Doe</td>
                          <td>@social</td>
                      </tr>
                    </>
                  )}
                </tbody>
            </table>

            {
                pagination ?
                <div className="tablePaginationWrapper">
                    <ul className="tablePagination">
                        <li><span className="active">1</span></li>
                        <li><span>2</span></li>
                        <li><span>3</span></li>
                        <li><span>4</span></li>
                        <li><span>5</span></li>
                    </ul>
                </div> : ""
            }
        </div>
    </div>
  );
};

export default Table;
